export const TYPE_LOGOUT = "/logout";
